import React from "react";
import CenteredModal from "../../../../../components/Modal/CenteredModal";

const PreviewModal = ({
  openPreviewModal,
  setOpenPreviewModal,
  selectedUser,
}) => {

  return (
    <CenteredModal
      title={"Preview Notification"}
      hasHeader={true}
      open={openPreviewModal}
      setOpen={setOpenPreviewModal}
      //  width={"w-[600px]"}
    >
      <p className="mt-4b text-wrap"> {selectedUser?.message}</p>
    </CenteredModal>
  );
};

export default PreviewModal;
